import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { LocationIcon } from './icons';

const MapContainer = styled(Box)(() => ({
  width: '100%',
  height: '320px',
  backgroundColor: '#F9FAFB',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  position: 'relative',
  overflow: 'hidden',
}));

const MapOverlay = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: '#F9FAFB',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '8px',
}));

const MapIcon = styled('div')(() => ({
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#9CA3AF',
  fontSize: '24px',
}));

export interface MapPlaceholderProps {
  address?: string;
  className?: string;
}

export const MapPlaceholder: React.FC<MapPlaceholderProps> = ({
  address,
  className,
}) => {
  return (
    <MapContainer className={className}>
      <MapOverlay>
        <MapIcon>
          <LocationIcon sx={{ fontSize: 32, color: '#9CA3AF' }} />
        </MapIcon>
        <Typography
          variant='body1'
          color='#4B5563'
          textAlign='center'
          sx={{ fontWeight: 500, mb: 0.5, fontSize: '14px' }}
        >
          Interactive map will appear here
        </Typography>
        <Typography
          variant='body2'
          color='#6B7280'
          textAlign='center'
          sx={{ fontSize: '14px' }}
        >
          {address
            ? `Location: ${address}`
            : 'Enter an address to see the location'}
        </Typography>
      </MapOverlay>
      <Box
        sx={{
          position: 'absolute',
          bottom: 8,
          right: 8,
          background: 'transparent',
          borderRadius: 1,
          p: 0.5,
        }}
      >
        <Typography variant='caption' color='#9CA3AF' sx={{ fontSize: '12px' }}>
          Map data ©2024
        </Typography>
      </Box>
    </MapContainer>
  );
};

export default MapPlaceholder;
